/* eslint-disable */
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { loadingStatus } from 'ggApp/modules/requestStatus/selectors';
import { compose } from 'recompose';
import LoadingOverlay from 'ggApp/shared/common/LoadingOverlay/LoadingOverlay';


export default compose(
    connect(
        createStructuredSelector({
            loading: loadingStatus,
        }),
    ),
)(LoadingOverlay);
